export default "__VITE_ASSET__BiJB2Kkv__"